import React from 'react';

type SectionTitleProps = {
    title?: string,
    subTitle?: string,
};

const SectionTitle: React.FC<SectionTitleProps> = ({ title, subTitle }: SectionTitleProps) => {
    if (!title && !subTitle) return null;

    return (
        <div>
            {title && (<h3 className="lesson-section-title">{title}</h3>)}
            {subTitle && (<div className="lesson-section-subtitle">{subTitle}</div>)}
        </div>
    );
};

export default SectionTitle;
